import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu/ActionMenu';
import { ActionMenuOption, AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { colors, spacing } from 'ui/theme';
import { SecondaryButton } from 'ui/button/shortcuts';
import { Edit16 } from 'ui/icons/action/Edit16';
import { Delete } from 'ui/icons/action/Delete';
import { Overflow } from 'ui/icons/navigation/Overflow';
import { MetricDefinition } from '../types';

const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;

export const displayContent = {
  edit: 'Edit metric definition',
  delete: 'Delete metric definition',
};

type TableActionsMenuProps = {
  row: MetricDefinition;
  handleEditClick: (row: MetricDefinition) => void;
  handleDeleteClick: (row: MetricDefinition) => void;
};

export const TableActionMenu = ({
  row,
  handleEditClick,
  handleDeleteClick,
}: TableActionsMenuProps) => {
  const overflowOptions: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Edit16 height={16} color={colors.grey50} />
          <span>{displayContent.edit}</span>
        </>
      ),
      id: 'edit',
      onClick: () => handleEditClick(row),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Delete height={18} color={colors.grey50} />
          <span>{displayContent.delete}</span>
        </>
      ),
      id: 'delete',
      onClick: () => handleDeleteClick(row),
    },
  ];

  return (
    <ActionMenu
      align={MENU_ALIGNMENTS.RIGHT}
      options={overflowOptions}
      data-test="admin-app-metric-definitions-actions"
    >
      <StyledButton>
        <Overflow color={colors.grey90} />
      </StyledButton>
    </ActionMenu>
  );
};
